export enum FormMode {
    FLEX = "flex",
    FORM_GRID = "form-grid"
}
